//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import classlist from 'keen-ui/src/helpers/classlist'

export default {
  name: 'ui-modal',

  props: {
    title: {
      type: String,
      default: 'UiModal title'
    },
    size: {
      type: String,
      default: 'normal' // 'small', 'normal', or 'large'
    },
    role: {
      type: String,
      default: 'dialog' // 'dialog' or 'alertdialog'
    },
    transition: {
      type: String,
      default: 'scale' // 'scale', or 'fade'
    },
    removeHeader: {
      type: Boolean,
      default: false
    },
    removeCloseButton: {
      type: Boolean,
      default: false
    },
    preventShift: {
      type: Boolean,
      default: false
    },
    dismissible: {
      type: Boolean,
      default: true
    },
    dismissOn: {
      type: String,
      default: 'backdrop esc close-button'
    }
  },

  data () {
    return {
      isOpen: false,
      lastfocusedElement: null
    }
  },

  computed: {
    classes () {
      return [
        `ui-modal--size-${this.size}`,
        { 'has-footer': this.hasFooter },
        { 'is-open': this.isOpen }
      ]
    },

    hasFooter () {
      return Boolean(this.$slots.footer)
    },

    toggleTransition () {
      return `ui-modal--transition-${this.transition}`
    },

    dismissOnBackdrop () {
      return this.dismissOn.indexOf('backdrop') > -1
    },

    dismissOnCloseButton () {
      return this.dismissOn.indexOf('close-button') > -1
    },

    dismissOnEsc () {
      return this.dismissOn.indexOf('esc') > -1
    }
  },

  watch: {
    isOpen () {
      this.$nextTick(() => {
        this[this.isOpen ? 'onOpen' : 'onClose']()
      })
    }
  },

  beforeDestroy () {
    if (this.isOpen) {
      this.teardownModal()
    }
  },

  methods: {
    open () {
      this.isOpen = true
    },

    close () {
      this.isOpen = false
    },

    closeModal (e) {
      if (!this.dismissible) {
        return
      }

      // Make sure the element clicked was the backdrop and not a child whose click
      // event has bubbled up
      if (e.currentTarget === this.$refs.backdrop && e.target !== e.currentTarget) {
        return
      }

      this.isOpen = false
    },

    onOpen () {
      this.lastfocusedElement = document.activeElement
      this.$refs.container.focus()

      // classlist.add(document.body, 'ui-modal--is-open')
      document.addEventListener('focus', this.restrictFocus, true)

      this.$emit('open')
    },

    onClose () {
      this.teardownModal()
      this.$emit('close')
    },

    redirectFocus () {
      this.$refs.container.focus()
    },

    restrictFocus (e) {
      if (!this.$refs.container.contains(e.target)) {
        e.stopPropagation()
        this.$refs.container.focus()
      }
    },

    teardownModal () {
      // classlist.remove(document.body, 'ui-modal--is-open')
      document.removeEventListener('focus', this.restrictFocus, true)

      if (this.lastfocusedElement) {
        this.lastfocusedElement.focus()
      }
    },

    onEnter () {
      this.$emit('reveal')
    },

    onLeave () {
      this.$emit('hide')

      // classlist.remove(document.body, 'ui-modal--is-open')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/modal/index.vue